import $ from 'jquery';
import React,{useState,useEffect} from 'react';
import {GetImgCertUser_CBack,btnSetColor_CBack,TableDatePicker} from '../function_lib/common_lib';

export function updCategoryForms(){
    
    GetImgCertUser_CBack(this,"#upd-request-form","editCategoryFroms",function(checkData,checkMsg,userMsg){
      if(checkData===-10){
        alert("Kindly fill required fields");
        return;
      }else {
        //Custom_Alert("Successfully Added",checkMsg,false);
        //alert(checkMsg);
        $('#divCategoryForms').modal('hide');
        window.location.reload();
      }
    });
}             
  
export const Comp_Category_Forms=(props)=>{
    
    useEffect(()=>{
        //setMyProfile(props.memberProfile);
    },[props.memberProfile])

    //alert(JSON.stringify(props));
        return(<div className="modal fade bd-example-modal-xl"  id="divCategoryForms" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-xl11" role="document">
          <div className="modal-content">
          <div className="modal-header bg-primary">
              <h5 className="modal-title text-white" id="exampleModalLabel">Edit Product</h5>
              <button type="button" className="close text-white" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true" className="text-white">&times;</span>
              </button>
            </div>
            <div className="modal-body">
            {props.memberProfile.length>0?
            <form enctype="multipart/form-data" method="POST" onsubmit="event.preventDefault()" className="contact-form-style form-control11 " name="upd-request-form" id="upd-request-form">
    <input type="hidden" name="curl_type" id="curl_type" value="editCategoryFroms" />  
                <input type="hidden" name="m_type" id="m_type" value="editCategoryFroms" />
                <input type="hidden" name="res_func" id="res_func" value="okSuccCont" />
                <input type="hidden" name="category_master_id" id="category_master_id" value={btoa(props.memberProfile[0]["category_master_id"])}/>
                <input type='hidden' name="request_form_master_id" id="request_form_master_id" value={btoa(props.memberProfile[0]["id"])}/>
        <div class="row">
            <div class="col-md-12 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Field Name:</strong></label>
                <input name="field_name" id="field_name" type="text" defaultValue={props.memberProfile[0]["field_name"]} class="form-control required" placeholder="Field Name" required/>
            </div>

            <div class="col-md-12 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Filed Type:</strong></label>
                <select className='form-control required' id="field_type" name="field_type">
                    <option value={"0"}>-Select-</option>
                    <option selected={props.memberProfile[0]["field_type"]==="date"} value={"date"}>Date</option>
                    <option selected={props.memberProfile[0]["field_type"]==="dropdown"} value={"dropdown"}>Dropdown</option>
                    <option selected={props.memberProfile[0]["field_type"]==="file"} value={"file"}>File</option>
                    <option selected={props.memberProfile[0]["field_type"]==="number"} value={"number"}>Number</option>
                    <option selected={props.memberProfile[0]["field_type"]==="text"} value={"text"}>Text</option>
                </select>

               
            </div>
            <div class="col-md-12 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Dropdown Option(s) if Any (, comma separated):</strong></label>
                <textarea id="option_if_any" name="option_if_any" defaultValue={props.memberProfile[0]["option_if_any"]} class="form-control"></textarea>
                
            </div>

            <div class="col-md-12 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Priority:</strong></label>
                <input name="priority" id="priority" defaultValue={props.memberProfile[0]["priority"]} type="number" class="form-control required" placeholder="Priority" required/>
            </div>
            
            <div class="col-md-12 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Category Status:</strong></label>
                <select className='form-control required' id="status" name="status">
                    <option value={"0"}>-Select-</option>
                    <option selected={props.memberProfile[0]["status"]==="Active"} value={"Active"}>Active</option>
                    <option selected={props.memberProfile[0]["status"]==="Inactive"} value={"Inactive"}>Inactive</option>
                </select>
            </div>
          
        </div>

        <div class="text-center mt-4">
            <button type="button" onClick={()=>updCategoryForms()} class="btn btn-primary me-2">Update</button>
            {/* <button type="reset" class="btn btn-secondary">Reset</button> */}
        </div>
    </form>:''}
          </div>
          </div>
          </div>
          </div>);
    
}
export default Comp_Category_Forms;
